import EventBus from '@/components/mixins/event-bus-mixin'
import { v4 as uuidv4 } from 'uuid'
import { omit } from 'lodash';

export default {
  name: 'fontList',
  inject: [
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {
  },
  props: {
    fontOptionsProp: {
      type: Object,
      default () { return '' }
    },
    uploadFontVisibileProp: {
      type: Boolean,
      default () { return true }
    }
  },
  watch: {
    fontOptionsProp (fontOptions) {
      this.setSelectedFont({ fontOptions })
    }
  },
  mixins: [],
  data () {
    return {
      fontUpload: {
        action: null,
        data: [],
        fileList: []
      },
      fontList: [],
      selectedFont: null,
      prevSelectedFont: '',
      isUploadFontVisibile: this.uploadFontVisibileProp
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('font-list-change', { action, payload: { data } })
      }
    },
    setSelectedFont ({ fontOptions }) {
      this.selectedFont = fontOptions?.fontFamily ?? null
    },
    isSelectedFontExistInList ({ selectedFont }) {
      let exist = false

      if (this.fontList && this.fontList.family) {
        exist = this.fontList.family.find((font) => font === selectedFont)

        if (!exist) {
          console.error(`${selectedFont} is not present in fonts list`)
        }
      }
    },
    getFontList ({ params = {}, callback = null }) {
      const apiRequest = () => {
        this.$api.get(`${CONFIG.API_BASE_URL}/font`)
          .then(response => {
            this.$utils.mainLoader(false)
            const responseData = this.$utils.clone(response.data)

            if (responseData.errors) { // Show notification dialog if there's an error from previous upload
              EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
                type: 'error',
                alert: {
                  message: responseData.errors
                },
                callbacks: {
                  eventOnClose: () => {
                    // Proceed to callback once notification is closed
                    if (callback) callback()
                  }
                }
              })
            } else {
              EventBus.$emit('HIDE_CUSTOM_NOTIFICATION', { type: 'success', messages: [] })
            }

            // Set new fonts list
            this.fontList = omit(responseData, ['errors'])

            // Set selected to one of the newly uploaded fonts
            if (params.newFontsUploaded) {
              const newFontFamilies = []
              for (const targetFontId of params.newFontsUploaded) {
                const newFont = this.fontList.fonts.find((font) => font.styles.some((style) => style.fontId === targetFontId))
                if (newFont) {
                  newFontFamilies.push(newFont.family)
                }
              }
              for (const fontFamily of newFontFamilies) {
                if (this.fontList.family.includes(fontFamily)) {
                  this.selectedFont = fontFamily
                  break
                }
              }
            }

            // Set new fontUpload data for next upload
            this.fontUpload = {
              action: responseData.post.url,
              data: (file) => {
                file.fontId = uuidv4()
                const data = this.$utils.clone(responseData.post.fields)
                data['x-amz-meta-fontid'] = file.fontId
                return data
              },
              fileList: []
            }

            this.isSelectedFontExistInList({ selectedFont: this.selectedFont })

            // Run callback if no error returned.
            // Response with errors will be handled
            // differently to show an error dialog, then
            // proceed with running the callback once the
            // dialog is closed.
            if (!responseData.errors && callback) callback()
          })
          .catch((error) => {
            this.error = error.message
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    handleFontSelectionChange () {
      const prevSelectedFont = this.prevSelectedFont

      if (this.selectedFont === 'addFont') {
        this.selectedFont = prevSelectedFont
        return
      }

      this.prevSelectedFont = this.selectedFont
      this.emitEvent('FONT_SELECTION_CHANGE', { fontSelection: this.selectedFont })
    },
    handleFontBeforeUpload (file) {
      this.$utils.mainLoader(true)
    },
    handleFontUploadChange (file) {
      const fontUpload = this.$utils.clone(this.fontUpload)

      // Check file if already in the list to be uploaded
      let isInProcessList = false
      for (const item of fontUpload.fileList) {
        if (item.uid === file.uid) {
          isInProcessList = true
        }
      }

      if (!isInProcessList) {
        const newFile = this.$utils.clone(file)
        newFile._edit = {}
        newFile._edit.request = {
          status: 'requesting',
          response: null
        }
        fontUpload.fileList.push(newFile)

        this.fontUpload = fontUpload
      }
    },
    handleFontUploadSuccess (response, file) {
      this.handleFileUploadAfterRequest(response, file, 'success')
    },
    handleFontUploadError (response, file) {
      this.handleFileUploadAfterRequest(response, file, 'error')
    },
    handleFileUploadAfterRequest (response, file, status) {
      const fontUpload = this.$utils.clone(this.fontUpload)
      let countDoneRequest = 0

      for (const fileItem of fontUpload.fileList) {
        if (fileItem.uid === file.uid) {
          fileItem._edit.request.status = status
          fileItem._edit.request.response = response
        }

        if (['error', 'success'].indexOf(fileItem._edit.request.status) >= 0) {
          countDoneRequest += 1
        }
      }
      this.fontUpload = fontUpload

      if (countDoneRequest >= fontUpload.fileList.length) {
        setTimeout(() => {
          this.getFontList({
            params: {
              newFontsUploaded: fontUpload.fileList.filter((item) => item._edit.request.status === 'success').map((item) => item.raw.fontId)
            },
            callback: () => {
              this.emitEvent('FONT_UPLOAD_DONE', { fontSelection: this.selectedFont })
            }
          })
        }, 15000)
      }
    }
  },
  mounted () {
    this.setSelectedFont({ fontOptions: this.fontOptionsProp })
    this.getFontList({})
  }
}
